<div class="section">
  <div class="section-top">
    <h3 class="section-title">Acțiuni Permisiuni</h3>
    <button class="section-btn" (click)="openAddDialog()">
      <img src="../../../../assets/icons/add.svg" alt="add" />
      Adaugă
    </button>
  </div>
  <div class="table-container">
    <table
      datatable
      [dtOptions]="dtOptions"
      [dtTrigger]="dtTrigger"
      class="row-border hover"
    ></table>
  </div>
  <div class="spinner"><mat-spinner *ngIf="isLoading"></mat-spinner></div>
</div>
